import axios, { getAuthHeaders } from "./config";

export default {
    createFile: function(disk, path, name, type, officeType) {
        return axios.post("file-manager/create-file", { disk, path, name, type, officeType }, { 
            headers: getAuthHeaders()
        });
    },

    updateFile: function(data) {
        return axios.post("file-manager/update-file", data, {
            headers: getAuthHeaders()
        })
    },
    createDirectory: function(data) {
        return axios.post("file-manager/create-directory", data, { 
            headers: getAuthHeaders()
        })
    },
    search: function(disk, path, searchPayload) {
        return axios.post("file-manager/search", { disk, path, searchPayload }, {
            headers: getAuthHeaders()
        })
    },
    share: function(data, config) {
        return axios.post(`file-manager/share`, data, config)
    },
    upload(data, config) {
        return axios.post(`file-manager/upload`, data , config)
    },
    rename: function(data) {
        return axios.post(`file-manager/rename`, data, {
            headers: getAuthHeaders()
        })
    },
    delete: function(data) {
        return axios.post(`file-manager/delete`, data, {
            headers: getAuthHeaders()
        })
    },
    paste: function(data) {
        return axios.post('file-manager/paste', data, {
            headers: getAuthHeaders()
        })
    },
    modify: function(data, config) {
        return axios.post(`file-manager/modify`, data , config)
    },
    zip: function(data) {
        return axios.post('file-manager/zip', data, {
            headers: getAuthHeaders()
        })
    },
    unzip: function(data) {
        return axios.post('file-manager/unzip', data, {
            headers: getAuthHeaders()
        })
    }
}